import XSelect from "../../../../components/common/XSelect";
import { useDownloadOptions } from "../../../../hooks/useDownloadOptions";
import { DEMAND, DEMAND_TYPE } from "@demandproai/shared";

const optionItemClasses =
    "cursor-pointer px-3 py-1.5 [margin:0_-12px] rounded-md block " +
    "transition-[background-color,color] duration-200 ease-out " +
    "hover:bg-primary-surface hover:text-primary hover:font-medium";

const LifeCareDropDown = ({ caseData, onClose }) => {
    const { downloadDemandDraft } = useDownloadOptions();
    const { _id, clients } = caseData;

    const lifeCareEnum = DEMAND_TYPE[DEMAND.Lifecare_Plan];
    if (clients.length === 1) {
        return <span className={optionItemClasses} onClick={() => {
            downloadDemandDraft({
                caseId: _id,
                typeOfDemandDraft: lifeCareEnum?.value,
                clientId: clients[0].clientId,
            }); onClose()
        }}> {DEMAND_TYPE[DEMAND.Lifecare_Plan]?.text}</span>
    }

    const optionArr = clients.map(client => ({
        text: `${client.personalInfo?.clientName} ${lifeCareEnum?.text}`,
        value: client.clientId
    }));
    return <XSelect
        emptyOption={true}
        label={<b>{DEMAND_TYPE[DEMAND.Lifecare_Plan]?.text}</b>}
        options={optionArr}
        className="h-8!"
        onChange={(e) => {
            downloadDemandDraft({
                caseId: _id,
                typeOfDemandDraft: lifeCareEnum?.value,
                clientId: e.target.value
            }); onClose()
        }}
    />
}

export default LifeCareDropDown;